import { render, staticRenderFns } from "./LectureListView.vue?vue&type=template&id=0d571ef3&"
import script from "./LectureListView.vue?vue&type=script&lang=ts&"
export * from "./LectureListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports